import { ViewComponent } from "./view";

export namespace ListComponent {
    export interface IProps<S = any> extends ViewComponent.IProps<S> {}

    export interface IState extends ViewComponent.IState {}

    export abstract class Base<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        static pageType = "list";
        static defaultProps = {
            ...ViewComponent.Base.defaultProps,
            classPrefix: "list",
        };
    }
}
